import { RouteObject } from 'react-router-dom';
import { RoutesEnum } from '~/constants/enums';
import CompanyInfo from '~/modules/myAccount/pages/CompanyInfo';
import CompanyUpdate from '~/modules/myAccount/pages/CompanyInfo/CompanyUpdate';

const routes: RouteObject[] = [
  {
    path: RoutesEnum.COMPANY_INFO,
    children: [
      { index: true, element: <CompanyInfo /> },
      {
        path: RoutesEnum.UPDATE,
        element: <CompanyUpdate />,
      },
    ],
  },
];

export default routes;
